<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Links</label>
      <div class="links-list">
        <div 
          v-for="(link, index) in localSettings.items" 
          :key="index"
          class="link-item"
        >
          <div class="link-fields">
            <input 
              v-model="link.text"
              type="text"
              class="form-input"
              placeholder="Link text"
              @input="emitUpdate"
            />
            <input 
              v-model="link.url"
              type="url"
              class="form-input"
              placeholder="https://example.com"
              @input="emitUpdate"
            />
          </div>
          <button 
            class="btn btn-sm btn-danger"
            @click="removeLink(index)"
            :disabled="localSettings.items.length === 1"
          >
            🗑️
          </button>
        </div>
      </div>
      <button class="btn btn-outline btn-sm mt-2" @click="addLink">
        ➕ Add Link
      </button>
    </div>

    <div class="form-group">
      <label class="form-label">Layout</label>
      <select v-model="localSettings.layout" class="form-select" @change="emitUpdate">
        <option value="vertical">Vertical</option>
        <option value="horizontal">Horizontal</option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  items: [{ text: 'Link 1', url: '#' }],
  layout: 'vertical',
  class: '',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function addLink() {
  if (!localSettings.value.items) localSettings.value.items = [];
  localSettings.value.items.push({ text: 'New Link', url: '#' });
  emitUpdate();
}

function removeLink(index) {
  if (localSettings.value.items.length > 1) {
    localSettings.value.items.splice(index, 1);
    emitUpdate();
  }
}

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.links-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.link-item {
  display: flex;
  gap: 8px;
  align-items: start;
}

.link-fields {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>

